import React, { useState } from 'react'
import {
  Dimensions,
  Modal,
  Platform,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import { SvgXml } from 'react-native-svg'
import { DateTime } from 'luxon'

import { color } from '../../theme'
import { Button } from '../button'
import { Text } from '../text'
import { iconRadioChecked, iconRadioUnchecked } from '../../assets'
import { SvgIcon } from '../svg-icon'
import { observer } from 'mobx-react-lite'
import { useStores } from '@trivie/core'

interface GDPRConsentModalProps {}
export const GDPRConsentModal = observer((props: GDPRConsentModalProps) => {
  const { userStore } = useStores()
  const { user } = userStore

  const [consent, setConsent] = useState<boolean | null>(null)
  const [submitted, setSubmitted] = useState<boolean>(false)

  const visible =
    user !== null && user?.workspace_settings?.gdpr_enabled && !user?.gdpr_consent?.consent_granted

  const contentStyle = {
    justifyContent: 'center',
    flexDirection: 'column',
    alignSelf: 'center',
    overflow: Platform.OS === 'web' ? 'auto' : 'scroll',
  }

  if (Platform.OS === 'web') {
    contentStyle['height'] = 700
  }

  return visible ? (
    <Modal style={{ backgroundColor: color.green }} visible transparent>
      <View
        style={{
          ...ROOT,
          // @ts-ignore
          backdropFilter: 'blur(5px)',
          paddingHorizontal: 20,
        }}
      >
        <View
          style={{
            ...CONTAINER,
            minHeight: submitted ? 375 : 512,
            width: Platform.OS === 'web' ? 575 : '100%',
            flex: submitted ? 0 : 0.8,
            justifyContent: 'center',
            alignSelf: 'center',
          }}
        >
          <View
            //@ts-ignore
            style={contentStyle}
          >
            {Platform.OS === 'web' ? (
              <div
                style={{
                  height: 32,
                  justifyContent: 'center',
                  flexDirection: 'row',
                  display: 'flex',
                  marginBottom: 16,
                }}
              >
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4379 31C12.4216 31 10.5374 30.6249 8.78514 29.8747C7.03291 29.1245 5.50271 28.096 4.19454 26.7892C2.88637 25.4824 1.86024 23.9457 1.11614 22.1792C0.372048 20.4126 0 18.5129 0 16.4801C0 14.4473 0.372048 12.5476 1.11614 10.781C1.86024 9.01444 2.87437 7.47775 4.15854 6.17096C5.4427 4.86417 6.9429 3.83568 8.65912 3.08548C10.3753 2.33528 12.2056 1.96019 14.1498 1.96019C15.23 1.96019 16.3221 2.06304 17.4263 2.26874C18.5304 2.47443 19.3705 2.71038 19.9466 2.97658V5.59016C19.9466 6.41296 19.6285 7.145 18.9925 7.7863C18.3564 8.4276 17.6303 8.74824 16.8142 8.74824H12.7096V11.6522C12.7096 12.112 12.5476 12.5053 12.2236 12.832C11.8995 13.1587 11.5095 13.322 11.0534 13.322H8.17306V16.4801H17.2822C17.7623 16.4801 18.1643 16.6434 18.4884 16.9701C18.8124 17.2968 18.9744 17.7022 18.9744 18.1862V22.7963H20.4146C21.1107 22.7963 21.7288 22.9899 22.2689 23.3771C22.8089 23.7642 23.175 24.2724 23.367 24.9016C24.4472 23.6674 25.2633 22.3425 25.8153 20.9268C26.3674 19.5111 26.6434 18.0773 26.6434 16.6253C26.6434 16.2623 26.6314 15.8206 26.6074 15.3004C26.5834 14.7801 26.5474 14.3626 26.4994 14.048H28.6597C28.7077 14.29 28.7437 14.6409 28.7677 15.1007C28.7917 15.5605 28.8037 16.0082 28.8037 16.4438C28.8037 18.4766 28.4317 20.3823 27.6876 22.161C26.9435 23.9397 25.9233 25.4824 24.6272 26.7892C23.331 28.096 21.8128 29.1245 20.0726 29.8747C18.3324 30.6249 16.4541 31 14.4379 31ZM12.7096 29.0035V25.7002C11.9175 25.7002 11.2395 25.4159 10.6754 24.8472C10.1113 24.2785 9.82927 23.5948 9.82927 22.7963V21.3443L2.41231 13.8665C2.3163 14.4231 2.25029 14.8769 2.21429 15.2278C2.17828 15.5786 2.16028 15.9598 2.16028 16.3712C2.16028 19.614 3.15641 22.4212 5.14866 24.7927C7.14092 27.1643 9.66125 28.5679 12.7096 29.0035ZM23.187 11.87C22.875 11.87 22.6169 11.7672 22.4129 11.5615C22.2089 11.3558 22.1069 11.0956 22.1069 10.781V5.48126C22.1069 5.16667 22.2089 4.90652 22.4129 4.70082C22.6169 4.49512 22.875 4.39227 23.187 4.39227H23.7631V2.94028C23.7631 2.14169 24.0331 1.45199 24.5732 0.871194C25.1132 0.290398 25.7673 0 26.5354 0C27.3035 0 27.9576 0.290398 28.4977 0.871194C29.0377 1.45199 29.3078 2.14169 29.3078 2.94028V4.39227H29.9199C30.2319 4.39227 30.4899 4.49512 30.694 4.70082C30.898 4.90652 31 5.16667 31 5.48126V10.781C31 11.0956 30.898 11.3558 30.694 11.5615C30.4899 11.7672 30.2319 11.87 29.9199 11.87H23.187ZM24.9872 4.39227H28.0836V2.94028C28.0836 2.48048 27.9396 2.08119 27.6516 1.74239C27.3635 1.40359 26.9915 1.23419 26.5354 1.23419C26.0794 1.23419 25.7073 1.40359 25.4193 1.74239C25.1312 2.08119 24.9872 2.48048 24.9872 2.94028V4.39227Z"
                    fill="#1B59F8"
                  />
                </svg>
              </div>
            ) : (
              <SvgXml
                style={{ alignSelf: 'center', marginBottom: 16 }}
                xml={`
                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4379 31C12.4216 31 10.5374 30.6249 8.78514 29.8747C7.03291 29.1245 5.50271 28.096 4.19454 26.7892C2.88637 25.4824 1.86024 23.9457 1.11614 22.1792C0.372048 20.4126 0 18.5129 0 16.4801C0 14.4473 0.372048 12.5476 1.11614 10.781C1.86024 9.01444 2.87437 7.47775 4.15854 6.17096C5.4427 4.86417 6.9429 3.83568 8.65912 3.08548C10.3753 2.33528 12.2056 1.96019 14.1498 1.96019C15.23 1.96019 16.3221 2.06304 17.4263 2.26874C18.5304 2.47443 19.3705 2.71038 19.9466 2.97658V5.59016C19.9466 6.41296 19.6285 7.145 18.9925 7.7863C18.3564 8.4276 17.6303 8.74824 16.8142 8.74824H12.7096V11.6522C12.7096 12.112 12.5476 12.5053 12.2236 12.832C11.8995 13.1587 11.5095 13.322 11.0534 13.322H8.17306V16.4801H17.2822C17.7623 16.4801 18.1643 16.6434 18.4884 16.9701C18.8124 17.2968 18.9744 17.7022 18.9744 18.1862V22.7963H20.4146C21.1107 22.7963 21.7288 22.9899 22.2689 23.3771C22.8089 23.7642 23.175 24.2724 23.367 24.9016C24.4472 23.6674 25.2633 22.3425 25.8153 20.9268C26.3674 19.5111 26.6434 18.0773 26.6434 16.6253C26.6434 16.2623 26.6314 15.8206 26.6074 15.3004C26.5834 14.7801 26.5474 14.3626 26.4994 14.048H28.6597C28.7077 14.29 28.7437 14.6409 28.7677 15.1007C28.7917 15.5605 28.8037 16.0082 28.8037 16.4438C28.8037 18.4766 28.4317 20.3823 27.6876 22.161C26.9435 23.9397 25.9233 25.4824 24.6272 26.7892C23.331 28.096 21.8128 29.1245 20.0726 29.8747C18.3324 30.6249 16.4541 31 14.4379 31ZM12.7096 29.0035V25.7002C11.9175 25.7002 11.2395 25.4159 10.6754 24.8472C10.1113 24.2785 9.82927 23.5948 9.82927 22.7963V21.3443L2.41231 13.8665C2.3163 14.4231 2.25029 14.8769 2.21429 15.2278C2.17828 15.5786 2.16028 15.9598 2.16028 16.3712C2.16028 19.614 3.15641 22.4212 5.14866 24.7927C7.14092 27.1643 9.66125 28.5679 12.7096 29.0035ZM23.187 11.87C22.875 11.87 22.6169 11.7672 22.4129 11.5615C22.2089 11.3558 22.1069 11.0956 22.1069 10.781V5.48126C22.1069 5.16667 22.2089 4.90652 22.4129 4.70082C22.6169 4.49512 22.875 4.39227 23.187 4.39227H23.7631V2.94028C23.7631 2.14169 24.0331 1.45199 24.5732 0.871194C25.1132 0.290398 25.7673 0 26.5354 0C27.3035 0 27.9576 0.290398 28.4977 0.871194C29.0377 1.45199 29.3078 2.14169 29.3078 2.94028V4.39227H29.9199C30.2319 4.39227 30.4899 4.49512 30.694 4.70082C30.898 4.90652 31 5.16667 31 5.48126V10.781C31 11.0956 30.898 11.3558 30.694 11.5615C30.4899 11.7672 30.2319 11.87 29.9199 11.87H23.187ZM24.9872 4.39227H28.0836V2.94028C28.0836 2.48048 27.9396 2.08119 27.6516 1.74239C27.3635 1.40359 26.9915 1.23419 26.5354 1.23419C26.0794 1.23419 25.7073 1.40359 25.4193 1.74239C25.1312 2.08119 24.9872 2.48048 24.9872 2.94028V4.39227Z" fill="#1B59F8"/>
                </svg>
            `}
              />
            )}
            <Text
              style={TITLE}
              variant="labelEmphasized"
              text="Processing Personal Data Under GDPR"
            />
            {submitted ? (
              <>
                <Text
                  disableLink
                  style={{
                    paddingHorizontal: 32,
                    textAlign: 'center',
                    color: color.shade70,
                    opacity: 0.8,
                    marginBottom: consent ? 0 : 32,
                  }}
                  variant="body1Medium"
                  tx={consent === false ? 'GDPR.declined' : 'GDPR.confirm'}
                />
                {consent ? (
                  <Text
                    style={{
                      marginBottom: 20,
                      paddingHorizontal: 32,
                      textAlign: 'center',
                      color: color.shade70,
                      opacity: 0.8,
                    }}
                    variant="body1Medium"
                    tx="GDPR.change"
                  />
                ) : null}
                {consent === false && (
                  <Button
                    onPress={() => {
                      userStore.logout()
                      setSubmitted(false)
                      setConsent(null)
                    }}
                    style={{
                      ...BUTTON,
                      marginBottom: 12,
                      backgroundColor: color.white,
                      borderWidth: 1,
                      borderColor: color.shade20,
                    }}
                  >
                    <Text
                      variant="body1Emphasized"
                      style={{ color: color.shade50 }}
                      tx={'Onboarding.Login.logOut'}
                    />
                  </Button>
                )}
                <Button
                  onPress={() => {
                    if (consent === false) {
                      setSubmitted(false)
                      setConsent(null)
                    } else {
                      userStore.getUser(user.id).then(() => {
                        setTimeout(() => {
                          setSubmitted(false)
                          setConsent(null)
                        }, 500)
                      })
                    }
                  }}
                  style={BUTTON}
                >
                  <Text
                    variant="body1Emphasized"
                    style={{ color: color.white }}
                    tx={consent === false ? 'Common.back' : 'Common.done'}
                  />
                </Button>
              </>
            ) : (
              <>
                <ScrollView contentContainerStyle={{ paddingHorizontal: 32 }}>
                  <Text
                    style={{ textAlign: 'left', color: color.shade70, opacity: 0.8 }}
                    variant="body1Medium"
                    text={`When you use Trivie products and services, we may collect certain non-personally identifiable information for purposes including improving our products and services, troubleshooting bugs, providing services to you, facilitating the provision of software updates, dynamically served content and product support as well as communicating with you. The non-personal information collected may include information about your computer, hardware, software, platform, game system, media, mobile device, and incident data, for example. We also collect other non-personal information such as username, user ID or persona, feature usage, game play statistics, scores and achievements, user rankings and click paths as well as other data that you may provide in surveys, and your account preferences.

If you are a resident of the European Economic Area (EEA), you have certain data protection rights, and we employ commercially reasonable steps to allow you to correct, amend, delete, or limit the use of your personal data at any time. If you wish to be informed what personal data we hold about you, and if you want it to be removed from our systems, please contact us privacy@trivie.com‍
              
In certain circumstances, you have the following data protection rights:‍
              
The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.‍
              
The right to object. You have the right to object to our processing of your personal data.‍
              
The right of restriction. You have the right to request that we restrict the processing of your personal information.‍
              
The right to data portability. You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.‍
              
The right to withdraw consent. You also have the right to withdraw your consent at any time where Trivie, Inc. relied on your consent to process your personal information.
              
Please note that we may ask you to verify your identity before responding to such requests.‍
              
You have the right to complain to a Data Protection Authority about our collection and use of your personal data. For more information, please contact your local data protection authority in the European Economic Area (EEA).
              
Whenever made possible, you can access, update or request deletion of your personal data directly within the Help section of the Registered Website. If you are unable to perform these actions yourself, please contact us at privacy@trivie.com to assist you.
              
Data Security and Integrity Contact Information
We use various safeguards to protect the personal information submitted to us, both during transmission and once we receive it. However, no method of transmission over the Internet or via mobile device, or method of electronic storage, is 100% secure. Therefore, while we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
              
Trivie uses personal information supplied by or on behalf of Registered Users solely to facilitate use of the Services by said users and, where relevant, their managers or administrators. Trivie will take reasonable steps to verify the validity of personal information supplied, for example by validating email addresses and/or the source of data supplied.
              
U.S. Government Agency Governing Authority
Trivie, Inc. is subject to the investigatory and enforcement powers of the Federal Trade Commission.
              
Contact Information
If you have any questions about this Privacy Policy or our treatment of the information you provide us, please write to us by email at privacy@trivie.com or by mail to Trivie, Inc., PO Box 12801, Dallas, Texas USA, Attn: Privacy.
              
We periodically update this Privacy Policy, and we may update this Privacy Policy from time to time by posting a new version online. Your continued use of the Website, the Services, and/or continued provision of personal data to us will be subject to the terms of the then-current Privacy Policy.`}
                  />
                </ScrollView>
                <View style={FOOTER}>
                  <View style={RADIO_GROUP}>
                    <TouchableOpacity
                      onPress={() => setConsent(true)}
                      style={{
                        flexDirection: 'row',
                        marginBottom: 10,
                        alignItems: Platform.OS === 'web' ? 'center' : 'stretch',
                      }}
                    >
                      <SvgIcon
                        src={consent ? iconRadioChecked : iconRadioUnchecked}
                        color="black"
                        size={24}
                      />
                      <Text
                        style={{ marginLeft: 14, top: 1, color: color.shade70, opacity: 0.8 }}
                        variant="body1Medium"
                        tx="Common.consent"
                      />
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={() => setConsent(false)}
                      style={{
                        flexDirection: 'row',
                        marginBottom: 10,
                        alignItems: Platform.OS === 'web' ? 'center' : 'stretch',
                      }}
                    >
                      <SvgIcon
                        src={consent === null || consent ? iconRadioUnchecked : iconRadioChecked}
                        color="black"
                        size={24}
                      />
                      <Text
                        style={{ marginLeft: 14, top: 1, color: color.shade70, opacity: 0.8 }}
                        variant="body1Medium"
                        tx="Common.doNotConsent"
                      />
                    </TouchableOpacity>
                  </View>
                  <Button
                    disabled={consent === null}
                    onPress={() => {
                      userStore.gdprConsent(user!.id, {
                        consent_granted: consent,
                        timestamp: DateTime.now().toUTC().toISO(),
                      })
                      setSubmitted(true)
                    }}
                    style={{
                      ...BUTTON,
                      backgroundColor: consent === null ? color.shade20 : color.blue,
                    }}
                  >
                    <Text
                      variant="body1Emphasized"
                      style={{ color: color.white }}
                      tx="Common.submit"
                    />
                  </Button>
                </View>
              </>
            )}
          </View>
        </View>
      </View>
    </Modal>
  ) : null
})

/**
 * Styling
 */
const ROOT: ViewStyle = {
  flex: 1,
  backgroundColor: color.shade20,
  flexDirection: 'column',
  justifyContent: 'center',
}
const BUTTON: ViewStyle = {
  height: 52,
  width: 222,
  alignSelf: 'center',
  backgroundColor: color.palette.blue,
  borderRadius: 16,
}
const CONTAINER: ViewStyle = {
  padding: 32,
  paddingTop: 37,
  paddingHorizontal: 0,
  borderRadius: 20,
  alignItems: 'center',
  flex: 0.8,
  margin: 20,
  backgroundColor: color.white,
  borderBottomLeftRadius: 20,
  borderBottomRightRadius: 20,
}
const TITLE: TextStyle = {
  alignSelf: 'center',
  color: color.black,
  textAlign: 'center',
  marginBottom: 24,
  paddingHorizontal: 32,
}
const FOOTER: ViewStyle = {
  backgroundColor: '#ffffff',
  shadowColor: 'rgba(0,0,0,1)',
  shadowOpacity: 0.08,
  shadowRadius: 40,
  shadowOffset: {
    height: -50,
    width: 0,
  },
}
const RADIO_GROUP: ViewStyle = {
  paddingHorizontal: 32,
  paddingTop: 26,
  alignSelf: 'center',
  marginBottom: 10,
  left: Platform.OS === 'web' ? 0 : Dimensions.get('screen').width / 8 - 42,
}
